var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_824_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6677 5.33284H20.0012L19.335 1.73262C18.9349 1.19209e-07 17.1348 0 16.1348 0H7.86673C6.86667 0 5.00031 -3.57628e-07 4.66653 1.73387L4.00025 5.33281H1.33384C0.600037 5.33281 0 5.93285 0 6.66666C0 7.40046 0.600037 8.0005 1.33384 8.0005H2.53392C2.20014 8.33303 2.00012 8.80055 2.00012 9.33309V14.6672C2.00012 15.7335 2.86642 16.6673 4.00025 16.6673H4.66653V18.3337C4.66653 19.2675 5.40034 20 6.33288 20C7.26669 20 7.99922 19.2662 7.99922 18.3337L8.00047 16.6673H16.001V18.3337C16.001 19.2675 16.7348 20 17.6673 20C18.6011 20 19.3337 19.2662 19.3337 18.3337L19.3349 16.6673H20.0012C21.135 16.6673 22.0013 15.7335 22.0013 14.6672V9.33309C22.0013 8.7993 21.8013 8.33303 21.4675 7.99925L22.6676 8.0005C23.4014 8.0005 24.0014 7.40046 24.0014 6.66666C24.0014 5.93285 23.4015 5.33284 22.6677 5.33284ZM16.801 2.66644L17.7349 7.33297H6.26663L7.20045 2.66644H16.801ZM6.00037 12.0008C5.26657 12.0008 4.66653 11.4007 4.66653 10.6669C4.66653 9.93313 5.26657 9.33309 6.00037 9.33309C6.73418 9.33309 7.33422 9.93313 7.33422 10.6669C7.33422 11.4007 6.73418 12.0008 6.00037 12.0008ZM18.0011 12.0008C17.2673 12.0008 16.6673 11.4007 16.6673 10.6669C16.6673 9.93313 17.2673 9.33309 18.0011 9.33309C18.7349 9.33309 19.335 9.93313 19.335 10.6669C19.335 11.4007 18.7349 12.0008 18.0011 12.0008Z",
    fill: "#2E84FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_824_29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommute);
export default __webpack_public_path__ + "static/media/commute.3db924deaa76cb6b0969dc223a621d70.svg";
export { ForwardRef as ReactComponent };